import { NgModule } from '@angular/core';
import { NumericInputDirective } from './numeric-input.directive';

@NgModule({
  declarations: [NumericInputDirective],
  exports: [NumericInputDirective]
})
export class NumericInputModule {}



// WEBPACK FOOTER //
// ./src/app/directives/numeric-input.module.ts